'use client'

import parseDate from "@/src/function/parser";
import Link from "next/link";
import { useEffect, useRef } from "react";
import Image from "next/image";

/**
 * Ce composant affiche un élément du calendrier et retourne vers la page de l'évènement adéquat.
 * @param {object} parametter - Paramètre du composant
 * @param {string} parametter.title - Titre de l'évènement
 * @param {string} parametter.mainPicture - Nom de l'image d'aperçu de l'article
 * @param {string} parametter.date - Date de publication de l'article en format mm-dd-yyyy
 * @param {string} parametter.buttonText - Texte du bouton s'affichant dans le cadre
 * @param {string|number} parametter.id - ID de l'article dans la base de donnée
 * @param {boolean} parametter.isPampou - Indique s'il s'agit d'un article du pampou ou non
 * @param {object} parametter.local - Dictionnaire du site web.
 * @param {'fr'|'en'|'nl'} parametter.lang - Langue du site web
 * @returns 
 */
export default function NewsCard({mainPicture,date,title,buttonText,lang,id,local,isPampou=false,isPIM}){

    var item = useRef(null); // Référence à l'élément HTML



    useEffect(() => {
        // Création de l'observateur
        if(item){
            const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        // Si l'élément entre dans la zone définie (viewport)
                        item.current.classList.remove("scale-75");
                    } else {
                        // Si l'élément sort de la zone définie
                        item.current.classList.add("scale-75");
                    }
                });
            }, {
                // Ajuste la zone d'observation (marge du viewport)
                root: null, // viewport entier
                rootMargin: "0px", // pas de marge
                threshold: 0.8, // déclenchement lorsque 50% de l'élément est visible
            });
    
            const element = item.current;
            if (element) observer.observe(element);
    
            // Nettoyage pour éviter des fuites de mémoire
            return () => {
                item = null
                if (element) observer.unobserve(element);
            };
        }


    }, [item]);

    return(
        <div ref={item} className={`shrink rounded-lg NewsCard shadow-xl size-full overflow-hidden ${isPampou && "Pampou"} md:scale-100 transition-all scale-75`}>
                <div className="w-full aspect-[2/1] relative flex flex-col">
                    <Image alt={mainPicture} fill src={`/api/images/${mainPicture}`} className="pt-2"/>
                    <div className="flex w-full h-full absolute z-10 inset-0 ">
                        <button className=" font-[700] m-auto button-primary-3 large-button">
                            <Link href={`/${lang}/${isPIM?`${local.staticPage.newsPIM}`:`${local.staticPage.news}`}/${id}/${title.replaceAll(" ","-")}`}>{buttonText}</Link>
                        </button>
                    </div>
                </div>

            <div className="p-6 NewsCard-Body text-left rounded-b-lg h-full">
                <Link href={`/${lang}/${isPIM?`${local.staticPage.newsPIM}`:`${local.staticPage.news}`}/${id}/${title.replaceAll(" ","-")}`}>
                    <p className="mb-2 text tracking-[3px]">{parseDate(date,local,true)}</p>
                    <h2 className=" font-bold text heading-5">{title}</h2>
                </Link>
            </div>
        </div>
    )   
}